<section id="content" *ngIf="lang">
  <div class="page page-profile">

    <!-- page header -->
    <div class="pageheader">
      <h2> {{lang?.treatment_register}} </h2>
      <div class="page-bar">
        <ul class="page-breadcrumb">
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.DASHBOARD"><i class="fa fa-home"></i>
              {{lang?.privacy}}
            </a>
          </li>
          <li>{{ lang?.treatment_register }}</li>
        </ul>
      </div>
    </div>

    <!-- page content -->
    <div class="pagecontent">

      <!-- row -->
      <div class="row">
        <div class="col-md-12">
          <div class="tile tile-simple">

            <!-- tile body -->
            <div class="tile-body deadline-name">
              <div role="tabpanel">

              </div>

            </div>

          </div>
        </div>
      </div>

    </div>
  </div>
</section>

